import { ADDRESS, EMAIL, GSTIN, PHONE_DISPLAY, GBP_URL, scrollToId } from "../data";
import { useLang } from "../i18n";

export const Footer = () => {
  const { s } = useLang();
  return (
  <footer className="relative bg-night pt-20 pb-10 grain" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center">
            <span className="inline-flex rounded-2xl bg-cream p-4 shadow-lg ring-1 ring-gold/60">
              <img
                src="/images/logo.png"
                alt="Shri Jamuna Dham Guest House — Vrindavan"
                className="h-20 w-auto"
                data-testid="footer-brand-logo"
              />
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
            {s.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">{s.footer.explore}</p>
          <ul className="mt-5 space-y-3 text-sm text-cream/70">
            {s.footer.links.map(([label, href]) => (
              <li key={href}>
                <button
                  onClick={() => scrollToId(href)}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  className="transition-colors duration-300 hover:text-saffron"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">{s.footer.contact}</p>
          <ul className="mt-5 space-y-3 text-sm text-cream/70">
            <li>{ADDRESS}</li>
            <li>
              <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="hover:text-saffron transition-colors duration-300" data-testid="footer-phone-link">
                {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} className="hover:text-saffron transition-colors duration-300" data-testid="footer-email-link">
                {EMAIL}
              </a>
            </li>
            <li>
              <a href={GBP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-saffron transition-colors duration-300" data-testid="footer-google-link">
                Google Business Profile
              </a>
            </li>
            <li className="text-cream/50">GSTIN: {GSTIN}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-cream/10 pt-8">
        <p className="text-xs text-cream/45" data-testid="footer-copyright">
          © {new Date().getFullYear()} Shri Jamuna Dham, Vrindavan. {s.footer.rights}
        </p>
        <p className="font-hindi text-lg text-gold/80">॥ राधे राधे ॥</p>
      </div>
    </div>
  </footer>
  );
};
